import { HeaderNav } from '@web/modules/header-nav'
import React from 'react'
import { Outlet } from 'react-router'
import { layoutVariants } from '../styles'

const { container } = layoutVariants()

const Layout = () => (
  <div className={container()}>
    <HeaderNav />
    <Outlet />
  </div>
)

export default Layout
